import { useTranslation } from "react-i18next";

interface TwoFactorCodeInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
  placeholder?: string;
}

export function TwoFactorCodeInput({
  value,
  onChange,
  error,
  disabled = false,
  placeholder = "000000",
}: TwoFactorCodeInputProps) {
  const { t } = useTranslation("two-factor-auth");

  return (
    <div>
      <label htmlFor="2fa-code" className="mb-2 block text-xs text-foreground">
        {t("codeInput.label")}
      </label>
      <input
        id="2fa-code"
        type="text"
        inputMode="numeric"
        pattern="[0-9]{6}"
        maxLength={6}
        placeholder={placeholder}
        autoComplete="one-time-code"
        required
        value={value}
        onChange={(e) => {
          const numericValue = e.target.value.replace(/[^0-9]/g, "").slice(0, 6);
          onChange(numericValue);
        }}
        disabled={disabled}
        className={`mt-1 block w-full appearance-none rounded-md border bg-transparent px-3 py-2 shadow-xs placeholder:text-muted-foreground focus:border-foreground focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-focus sm:text-sm ${
          error ? "border-destructive" : ""
        }`}
      />
      {error && <p className="mt-1 text-xs text-destructive">{error}</p>}
    </div>
  );
}
